import { useState } from "react";
import { NavLink } from "react-router-dom";

type Props = {
  to: string;
  className?: string;
  content?: string;
  children?: React.ReactNode;
  mobile?: boolean;
};

const NavItem: React.FC<Props> = ({
  to,
  className,
  content,
  children,
  mobile,
}) => (
  <NavLink
    to={to}
    className={
      className ||
      `m-auto lg:mx-8  lg:block  cursor-pointer link-underline text-lg whitespace-nowrap font-[Poppins] h-10 font-bold text-center w-full lg:w-auto ${
        mobile ? "" : "hidden"
      }`
    }
    activeClassName="active"
  >
    {content || children}
  </NavLink>
);

const Navbar: React.FC = () => {
  const [mobile, setMobile] = useState(false);

  return (
    <nav
      className={`flex flex-col lg:flex-row p-6 transition-[height] ${
        mobile ? "h-72" : "h-20"
      }`}
      onClick={() => {
        if (window.screen.width < 1024) {
          setMobile(!mobile);
        }
      }}
    >
      <div className="flex lg:ml-8 mr-auto justify-around lg:justify-start w-full">
        <NavItem to="/" className="flex">
          <span className="font-bold uppercase text-center text-[25px] mr-2 my-auto font-[Montserrat] hidden md:block">
            KithulgodAranya
          </span>
          <img
            src="/assets/dharma_chakra.svg"
            alt=""
            className="w-14 h-14 lg:w-10 lg:h-10"
          />
        </NavItem>
        <img
          src="/assets/bars.svg"
          alt="ok"
          onClick={() => setMobile(!mobile)}
          className="lg:hidden ml-auto my-auto w-8"
        />
      </div>

      <NavItem to="/about" content="About" mobile={mobile} />
      <NavItem to="/contact" content="Contact Us" mobile={mobile} />
      <NavItem to="/gallery" content="Gallery" mobile={mobile} />
      <NavItem to="/events" content="Events" mobile={mobile} />
    </nav>
  );
};

export default Navbar;
